var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames, formatDateString, titleCase } from '@shapeable/utils';
import { filter, identity } from 'lodash';
import { LabelledValue } from '../elements/labelled-value';
var cls = classNames('entity-meta');
// -------- Types -------->
// -------- Props -------->
export var entityMetaDateTransform = function (value) {
  return formatDateString(value, 'D MMM YYYY');
};
export var EntityMetaDefaultProps = {
  fields: [],
  labels: {},
  fieldTransforms: {
    published: entityMetaDateTransform,
    created: entityMetaDateTransform,
    updated: entityMetaDateTransform
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n  "], ["\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n  "])), theme.UNIT(1))
});
var ItemStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: 1em;\n  "], ["\n    font-size: 1em;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.ul(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Item: styled(LabelledValue)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles)
};
export var EntityMeta = function (props) {
  var className = props.className,
    children = props.children,
    entity = props.entity,
    fields = props.fields,
    labels = props.labels,
    fieldTransforms = props.fieldTransforms,
    labelledValueProps = __rest(props, ["className", "children", "entity", "fields", "labels", "fieldTransforms"]);
  var values = filter(fields.map(function (field) {
    return entity[field];
  }));
  if (!values.length) {
    return null;
  }
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, fields.map(function (field) {
    var transform = fieldTransforms[field] || identity;
    var value = transform(entity[field]);
    if (!value) {
      return null;
    }
    var label = labels[field] || titleCase(field);
    return React.createElement(My.Item, __assign({
      tag: "li"
    }, labelledValueProps, {
      key: field,
      label: label,
      value: value
    }));
  }));
};
EntityMeta.defaultProps = EntityMetaDefaultProps;
EntityMeta.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;